import { borderTokens } from './border';
import { colorTokens } from './color';
import { iconTokens } from './icon';
import { paletteTokens } from './palette';
import { shadowTokens } from './shadow';
import { spacingTokens } from './spacing';
import { textStyleTokens } from './text-style';
import { typographyTokens } from './typography';
import { breakpointTokens } from './breakpoint';
import { durationTokens } from './duration';
import { easingTokens } from './easing';
import { transitionTokens } from './transition';
var TOKENS = {
  palette: paletteTokens,
  color: colorTokens,
  border: borderTokens,
  shadow: shadowTokens,
  icon: iconTokens,
  spacing: spacingTokens,
  typography: typographyTokens,
  textStyle: textStyleTokens,
  breakpoint: breakpointTokens,
  duration: durationTokens,
  easing: easingTokens,
  transition: transitionTokens
};
export default TOKENS;